import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import all from './all';
import items from './items';
import products from './products';
import destroyProducts from './destroyProducts';
import transactions from './transactions';
import transactionsV2 from './transactionsV2';
import transactionsV2All from './transactionsV2All';
import stockManagement from './stockManagement';
import transactionTypes from './transactionTypes';
import search from './search';

export default {
  destroy,
  store,
  show,
  update,
  all,
  items,
  products,
  transactions,
  transactionsV2,
  transactionsV2All,
  stockManagement,
  transactionTypes,
  search,
  destroyProducts,
};



// WEBPACK FOOTER //
// ./src/app/services/warehouse/index.js